import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { VisynAppProvider } from 'visyn_core/app';
import { store } from './store/store';
import { App } from './App';
import '@mantine/core/styles.css';
import 'mantine-react-table/styles.css';
import '@mantine/charts/styles.css';
import '@mantine/notifications/styles.css';


createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
    <Provider store={store}>
      <VisynAppProvider appName="App Template">
        <App />
      </VisynAppProvider>
    </Provider>
  // </React.StrictMode>,
);
